<template>
  <NxSelect
    :value="localValue"
    :options="listOptions"
    labelText="Tipos de Evento:"
    id="selectTipoEvento"
    placeholder="Selecione o(s) tipo(s) de evento"
    :multiple="true"
    @update:value="handleValueUpdate"
  ></NxSelect>
</template>
<script>
import { toast } from '@/shared/utils/UIHelper'
import { useReactiveModelMixin } from '../../mixins'
import EventTypeRepository from '@/shared/http/repositories/configurations/eventtype.js'

export default {
  name: 'NxSelectTipoEvento',
  mixins: [ useReactiveModelMixin('value') ],
  data () {
    return {
      listOptions: [],
      selected: null
    }
  },
  created () {
    this.onLoadEventos()
  },
  methods: {
    onLoadEventos () {
      EventTypeRepository.GetAll()
        .then((response) => {
          console.log(response)
          let result = response.data.content
            .map((x) => ({'value': x.id, 'text': x.nome}))
          this.listOptions = result
        })
        .catch((err) => {
          toast.error('Não foi possível carregar a lista de Eventos', 'Erro')
          console.error(err)
        })
    },
    handleValueUpdate (val) {
      this.localValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/nexum/components/custom-selects/NxSelectTipoEvento.vue